import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { loadAccount } from '../../../actions/account';
import bt from '../../commonStyle.css';
import messages from '../../../locale/messages';
import DocumentUpload from '../../DocumentUpload/DocumentUpload';
import { Col, Grid } from 'react-bootstrap';

class DniVerification extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}
	async handleClick() {
		const { nextPage, loadAccount, account } = this.props;
		await loadAccount();
		if (account.verification.isPhoneVerified) {

		} else { }

		nextPage('payment');
	}

	render() {
		const { formatMessage } = this.props.intl;

		return (
			<Grid>
				<Col xs={12} sm={12} md={9} lg={9} >
					<h3 className={'textWhite'}>
						<FormattedMessage {...messages.documentverificaiton} />
					</h3>

					<p><FormattedMessage {...messages.documentverificaitonDescription} /></p>
					<DocumentUpload placeholder={formatMessage(messages.documentUploadPlaceholder)} />
				</Col>
			</Grid>
		);
	}
}

const mapState = (state) => ({
	account: state.account.data,
});

const mapDispatch = {
	loadAccount
};

export default injectIntl(withStyles(bt)(connect(mapState, mapDispatch)(DniVerification)));